import React from 'react';
import { Link } from 'react-router-dom';

export default class Patients extends React.Component {
  render() {
    return <div className="content">
      <h3 className="title is-3">Patients</h3>
      <h3 className="subtitle">Retrieve a Patient</h3>
      <p>This section covers how to retrieve an individual patient</p>

      <h3 className="subtitle">HTTP Request</h3>
      <p><code>GET https://api.ccihub.com/api/patients/{`{id}`}</code></p>
      
      <h3 className="subtitle">Request Parameters</h3>
      <table className="table">
        <thead>
          <th>Parameter</th>
          <th>Required</th>
          <th>Type</th>
          <th>Description</th>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>yes</td>
            <td>string</td>
            <td>The id of the patient to be retrieved</td>
          </tr>
        </tbody>
      </table>

      <h3 className="subtitle">Response Parameters</h3>
      <table className="table">
        <thead>
          <th>Property</th>
          <th>Description</th>
        </thead>
        <tbody>
          <tr>
            <td>first_name</td>
            <td>The first name of the patient</td>
          </tr>
          <tr>
            <td>last_name</td>
            <td>The last name of the patient</td>
          </tr>
          <tr>
            <td>email</td>
            <td>The email address of the patient</td>
          </tr>
          <tr>
            <td>patient_id</td>
            <td>A unique identifier for the patient</td>
          </tr>
          <tr>
            <td>username</td>
            <td>A human readable username for the patient, if not set will be the patient_id</td>
          </tr>
          <tr>
            <td>gender</td>
            <td>A string representing the patient's gender, will be "F" or "M"</td>
          </tr>
          <tr>
            <td>zip</td>
            <td>The patient's zip code on record</td>
          </tr>
          <tr>
            <td>alerts</td>
            <td>An array of alerts for display purposes</td>
          </tr>
          <tr>
            <td>permissions</td>
            <td>Contact and data sharing preferences for the patient</td>
          </tr>
          <tr>
            <td>engaged_practice</td>
            <td>Data for study specific subjects, includes data liberation settings</td>
          </tr>
          <tr>
            <td>integrations</td>
            <td>An array of 3rd party oauth integration data</td>
          </tr>
          <tr>
            <td>access_code</td>
            <td>Access code patient used to register</td>
          </tr>
          <tr>
            <td>visits</td>
            <td>An array of visit configurations for the patient with embedded assessments</td>
          </tr>
        </tbody>
      </table>

      <h3 className="subtitle">Sample Response for Permissions</h3>
      <div className="code-snippet">
<pre><code>
{`{
  "email": true,
  "phone": false,
  "phone_number": '555-555-5555',
  "share": true
}`}
</code></pre>
      </div>

      <h3 className="subtitle">Sample Response for Engaged Practice</h3>
      <div className="code-snippet">
<pre><code>
{`{
  "site_id": null,
  "subject_id": null,
  "liberated": {
    "pin": null,
    "date": null,
    "email": null,
    "sync": false,
    "sync_id": null,
    "locked": null,
    "invalids": 0,
    "complete": null
  }
}`}
</code></pre>
      </div>

      <h3 className="subtitle">Sample Response for Integrations</h3>
      <div className="code-snippet">
<pre><code>
{`{
  "_id": {
      "$oid": "5904de876788006f6a11ee79"
  },
  "expires_at": 1521409673,
  "provider": "fitbit",
  "refresh_token": "1e514eaf9f97b12944ec6181d5f12007782392f98c",
  "secret": null,
  "token": "eyJhbGciOiJIUzI1NiJ9.TXjK0yInIJ3CJI3_vhQiEB4m4arhgpsOXr0yjQ-tuCI",
  "userid": "3ZJB95"
}`}
</code></pre>
      </div>

      <h3 className="subtitle">Sample Response for Visits</h3>
      <p>Additional information on visit and assessment properties can be found in the <Link to="/api/visits">Visits</Link> section</p>
      <div className="code-snippet">
<pre><code>
{`{
  "_id": {
      "$oid": "55df207e6363695256731600"
  },
  "assessments": [
      {
          "_id": {
              "$oid": "55df207e6363695256751600"
          },
          "created_at": null,
          "do_not_integrate": false,
          "finish": null,
          "legacy_session_id": 0,
          "name": "Depression",
          "reviewed": false,
          "sbr_scores": {
              "scores": [],
              "before": false,
              "after": false
          },
          "scale_id": 3,
          "scores": {},
          "start": null,
          "start_question_id": "1",
          "updated_at": null
      }
  ],
  "conditions": [],
  "created_at": null,
  "finish": null,
  "legacy_id": 0,
  "legacy_sync": true,
  "medications": [],
  "order": 1,
  "paused": {},
  "reminder": "none",
  "start": null,
  "status": null,
  "treatments": [],
  "triggered": false,
  "type": "Follow-Up",
  "updated_at": null
}`}
</code></pre>
      </div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/api/Patients.js